<template>
  <div class="page">
    <div
      class="banner"
      :style="{ backgroundImage: `url(${detailtem.coverUrl})` }"
    ></div>
    <div class="topic-wrap">
      <div class="left">
        <div class="top s10 t1 bold">
          {{ dayjs(detailtem.publishTime).format('MM月DD日') }}&nbsp;{{
            detailtem.title
          }}
        </div>
        <div class="bottom s5 t2">{{ detailtem.descritption }}</div>
      </div>
      <div class="right" @click="showPop()">
        <div class="date"></div>
        <div class="font s4 t3">往期回顾</div>
      </div>
    </div>
    <div class="space b2"></div>
    <div class="gold-point-wrap" v-if="dianJinItems.length > 0">
      <div
        class="gold-point border-1px-b"
        v-for="(item, index) in dianJinItems"
        :key="index"
        @click="goto(item.data.uri)"
      >
        <div class="left">
          <div class="name s9 t1">{{ item.data.title }}</div>
          <div class="time s4 t3">
            {{ dayjs(item.data.publishTime).format('MM-DD HH:mm') }}
          </div>
        </div>
        <div
          class="right"
          :style="{ backgroundImage: `url(${item.data.coverImageUrl})` }"
        ></div>
      </div>
    </div>
    <div class="space b2"></div>
    <div class="silk-bag-wrap" v-if="jinNangItems.length > 0">
      <div class="title s10 t1 bold border-1px-b">投资锦囊</div>
      <div
        class="silk-bag border-1px-b"
        v-for="(item, index) in jinNangItems"
        :key="index"
        @click="goto(item.uri)"
      >
        <div class="left">
          <div class="top s9 t1 bold">{{ item.data.title }}</div>
          <div class="bottom s4 t3" v-html="handletag(item.data.tags)"></div>
        </div>
        <div class="right">
          <div
            class="top s11 bold digitFont"
            :class="[getSymbol(item.data.glYield) >= 0 ? 'c1' : 'c3']"
          >
            {{ item.data.glYield }}
          </div>
          <div class="bottom s4 t3">总收益</div>
        </div>
      </div>
    </div>
    <div class="space b2"></div>
    <div class="course-wrap" v-if="courseItems.length > 0">
      <div class="title s10 t1 bold border-1px-b">名师课程</div>
      <div
        class="course border-1px-b"
        v-for="(item, index) in courseItems"
        :key="index"
        @click="goto(item.uri)"
      >
        <div
          class="left"
          :style="{ backgroundImage: `url(${item.data.coverImagUrl})` }"
        >
          <div class="tag">
            <div class="icon" :class="['tag' + item.data.courseSetType]"></div>
            <div class="font s2 t5">{{ item.data.tag }}</div>
          </div>
        </div>
        <div class="right">
          <div class="name-wrap">
            <div class="name s9 t1 bold">{{ item.data.title }}</div>
            <!-- <div class="time s4 t3">2020.06.01更新至15节</div> -->
            <div class="time s4 t3">{{ item.data.subTitle }}</div>
          </div>
          <div class="author s4 t3">{{ item.data.authorName }}</div>
        </div>
      </div>
    </div>
    <div class="space b2"></div>
    <NoticePopup
      v-model="hasNoticePopup"
      @emitId="handleId"
      :fatherId="id"
    ></NoticePopup>
  </div>
</template>
<script>
import NoticePopup from '@/components/NoticePopup'
import { GetSubject } from '@/api/user.js'
import dayjs from 'dayjs'
import ym from '@/assets/js/ym'
import appInfo from '@/assets/js/appInfo.js'
import http from '@/api/http'
import config from '@/api/config'
import Urls from '@/assets/js/Urls'

export default {
  name: 'Home',
  components: {
    NoticePopup
  },
  data() {
    return {
      hasNoticePopup: false,
      id: appInfo.getParam('id') || 0,
      detail: '',
      dianJinItems: [],
      jinNangItems: [],
      courseItems: [],
      weChatAppId: '31',
      weChatAppKey: null
    }
  },
  computed: {
    detailtem() {
      return this.detail
    }
  },
  created() {
    Promise.all([this.setWeChatAppInfo(), this.GetSubject()]).then(() => {
      this.showMenuItems()
    })
  },
  methods: {
    dayjs,
    handletag(tags) {
      let text = ''
      const length = tags.length - 1
      tags.forEach((item, index) => {
        text = text + item.text
        if (index !== length) {
          text = text + '&nbsp;|&nbsp;'
        }
      })
      return text
    },
    getSymbol(number) {
      const dig = parseFloat(number)
      return dig
    },
    handleId(id) {
      this.id = id
      this.GetSubject()
      this.hasNoticePopup = false
    },
    showPop() {
      this.hasNoticePopup = true
    },
    async GetSubject() {
      const { result, detail } = await GetSubject(this.id)

      if (result.code === 0) {
        this.detail = detail
        this.dianJinItems = detail.dianJinItems
        this.courseItems = detail.courseItems
        this.jinNangItems = detail.jinNangItems
      }
    },
    goto(url) {
      ym.openurl(url)
    },
    async setWeChatAppInfo() {
      if (!this.weChatAppKey) {
        const { detail } = await http.get(
          `${Urls.DOMAIN_YKT}/account/WeChat/GetWeChatAppId`,
          {
            AppId: this.weChatAppId
          }
        )
        this.weChatAppKey = detail
        console.log('this.weChatAppKey:')
        console.log(this.weChatAppKey)
      }
    },
    showMenuItems() {
      this.setWeChatAppInfo()
      if (ym.isSharePopEnable()) {
        ym.showMenuItems({
          menuItems: [
            {
              callback: () => {
                ym.showSharePop({
                  title: this.detail.title,
                  content: '有看投',
                  url:
                    config.h5Url +
                    '/ykthtml/selected-topics/?id=' +
                    this.detail.id +
                    '&appId=' +
                    this.weChatAppId +
                    '&wxAppId=' +
                    this.weChatAppKey
                })
              },
              icon:
                'https://appstatic.emoney.cn/images/20210419/9365ccedef860827d27e3ac32c638071.png'
            }
          ]
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.course-wrap {
  .title {
    height: 94px;
    display: flex;
    align-items: center;
    padding: 0 30px;
  }
  .course {
    height: 260px;
    display: flex;
    align-items: center;
    padding: 0 30px;
    .left {
      position: relative;
      height: 180px;
      flex: 0 0 180px;
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: 10px;
      margin-right: 30px;
    }
    .tag {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 90px;
      height: 36px;
      background: url('./images/tagbj.png') no-repeat;
      background-size: cover;
      display: flex;
      align-items: center;
      justify-content: center;
      .icon {
        width: 20px;
        height: 20px;
        background-repeat: no-repeat;
        background-size: cover;
        margin-right: 10px;
        &.tag1 {
          background-image: url('./images/tag1.png');
        }
        &.tag2 {
          background-image: url('./images/tag2.png');
        }
        &.tag3 {
          background-image: url('./images/tag3.png');
        }
        &.tag4 {
          background-image: url('./images/tag4.png');
        }
      }
    }
    .right {
      height: 180px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .time {
        margin-top: 22px;
      }
    }
  }
}
.silk-bag-wrap {
  .silk-bag {
    min-height: 154px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    .bottom {
      margin-top: 20px;
    }
    .left {
      margin-right: 20px;
    }
    .right {
      text-align: right;
    }
  }
  .title {
    height: 94px;
    display: flex;
    align-items: center;
    padding: 0 30px;
  }
}
.gold-point {
  min-height: 210px;
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
  align-items: center;
  .left {
    display: flex;
    min-height: 150px;
    flex-direction: column;
    justify-content: space-between;
    margin-right: 18px;
  }
  .right {
    flex: 0 0 200px;
    height: 150px;
    border-radius: 5px;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
.topic-wrap {
  display: flex;
  padding: 40px 30px;
  justify-content: space-between;
  .bottom {
    margin-top: 20px;
  }
  .left {
    margin-right: 20px;
  }
  .right {
    display: flex;
    align-items: flex-start;
    flex: none;
  }
  .date {
    width: 26px;
    height: 26px;
    margin-right: 10px;
    background: url('./images/date.png') no-repeat;
    background-size: 100%;
  }
}
.bold {
  font-weight: 700;
}
.banner {
  padding-bottom: 264/750 * 100%;
  // height: 264px;
  background-repeat: no-repeat;
  background-size: cover;
}
.space {
  height: 20px;
}
</style>
